import { db } from "@/firebase/firebaseConfig.js";

class AisService {

  getStaticInfo(vesselId) {
    return new Promise((resolve, reject) => {
      db.collection("vessel_info")
        .doc(vesselId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            resolve(doc.data());
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  getDynamicAisInfo(vesselId) {
    return new Promise((resolve, reject) => {
      db.collection("vessel_position")
        .doc(vesselId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            resolve(doc.data());
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

}

export default new AisService();
